const content = {
  component: "PageTypeA",
  cssClass: "page-welcome",
  meta: {
    title: "Welcome to the latest edition of Your Tomorrow, Today!",
    description:
      "From cloud to blockchain, here’s how technology is enabling businesses to reach their full potential.",
    og: {
      type: "website",
      title: "Read stories of tech innovation—see more",
      description: `Whether it's saving the lives of bees or scaling ethical chocolate start-ups, the possibilities of technology are endless. Click here to discover some of the most inspiring stories of digital transformation from across the world of business.  `,
      image: require("../../assets/images/social/welcome-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title:
        "Discover how technology is driving transformation across business",
      description: `From scaling Brazilian wine start-ups to transforming the olive oil supply chain, here are the stories of how pioneering technology is enabling businesses to thrive.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/welcome-300x300.jpg")
    }
  },
  title:
    "<span>Welcome to the Latest Edition of </span><span>Your Tomorrow, Today!</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/welcome-pre.jpg"),
    loaded: require("../../assets/images/bgs/welcome.jpg"),
    mobile: require("../../assets/images/bgs/welcome-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [true, "top center"]
    },
    mobile: {
      customPosition: [true, "center -20px"]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
          Why Your Tomorrow, Today? Every day, we see our customers realise their business visions through innovation—using secure cloud technology to reach strategic goals more quickly than they ever imagined.
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>Discover how <b>Certified Origins</b> is ensuring 100% transparency on provenance and authenticity each time a customer drizzles, sautées, or dips into some delicious Tuscan Oil, through the power of blockchain.</p>
          <p>Be amazed by how <b>CargoSmart</b>, a global shipping software solution provider, is reducing the more than than 30 people and 200 documents involved in simply getting a shipment ready to sail from port. A simplified supply chain is leading to more trust and reliability.</p>
          <p>Delight in how Dutch investigative journalist Teun "Tony" van de Keuken and two fellow journalists founded  and grew <b>Tony's Chocolonely</b>, based on the principle of producing only "slave-free chocolate"—and influencing other chocolate makers to do the same.</p>
          <p>You'll be amazed by Wine e-commerce merchant Wine.com.br who has taken the unusual step of trying to develop a wine-loving culture in a country where one barely existed before.</p>
          <p>Find out how Oracle has partnered with the World Bee Project to gather data around the world's main pollinators, allowing researching to "listen" into hives and understand when they will swarm.</p>
          <p>Learn how <b>National Instruments</b>, the Austin, Texas-based maker of modular hardware platforms and system design software for engineers is focusing its talent on several high-growth areas, including semiconductor testing, 5G wireless, connected vehicles, and the industrial Internet of Things.</p>
          <p>Each story shows how innovative and forward-thinking organisations can deliver tomorrow, today.</p><p>That's what we celebrate within Your Tomorrow, Today.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionAuthor",
      content: {
        author: "Amanda Jobbins",
        position: "VP Demand Generation & Marketing EMEA/APAC",
        image: require("../../assets/images/people/amanda-jobbins.png"),
        type: "author"
      }
    }
  ]
};

export default content;
